import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "003_billing_policy_settings",
  version: "0.1.0",
  sql: `
ALTER TABLE \`dormitory_settings\` ADD COLUMN \`rent_charge_timing\` text DEFAULT 'start_of_period' NOT NULL;
ALTER TABLE \`dormitory_settings\` ADD COLUMN \`billing_cycle_start_day\` integer DEFAULT 1 NOT NULL;
ALTER TABLE \`dormitory_settings\` ADD COLUMN \`invoice_issue_day\` integer DEFAULT 1 NOT NULL;
ALTER TABLE \`dormitory_settings\` ADD COLUMN \`prorate_policy\` text DEFAULT 'daily' NOT NULL;
ALTER TABLE \`dormitory_settings\` ADD COLUMN \`utility_billing_mode\` text DEFAULT 'metered' NOT NULL;
ALTER TABLE \`dormitory_settings\` ADD COLUMN \`advance_rent_months\` integer DEFAULT 1 NOT NULL;
ALTER TABLE \`dormitory_settings\` ADD COLUMN \`deposit_months\` integer DEFAULT 1 NOT NULL;
`,
};
